// Firebase
import { initializeApp } from "firebase/app"
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore"
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const usingEmulator = false;

/**
const firebaseApp = initializeApp({
  apiKey: "AIzaSyDOtsfb-s569GxI2-5PeIcZ5KSzAdxJNb8",
  authDomain: "page-parrot-prototype.firebaseapp.com",
  projectId: "page-parrot-prototype",
  storageBucket: "page-parrot-prototype.appspot.com",
  messagingSenderId: "1039223379534",
  appId: "1:1039223379534:web:ad8727054d307a160f551f",
  //measurementId: "G-D27X09QJYK"
});
 */

const firebaseApp = initializeApp({
    apiKey: "AIzaSyC5ioopy0fIUzfl5nUIjt1t77wLnFqS2dM",
    authDomain: "app.pageparrot.com",
    projectId: "pageparrot1",
    storageBucket: "pageparrot1.firebasestorage.app",
    messagingSenderId: "851192494812",
    appId: "1:851192494812:web:ce83252835c91da24e9219",
    measurementId: "G-XDD61TYDWD"
});


// Initialize services
const firestoreDB = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);
const storage = getStorage(firebaseApp);
const functions = getFunctions(firebaseApp);

// Connect to emulators in development
if (usingEmulator) {
  connectFirestoreEmulator(firestoreDB, 'localhost', 8080);
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectStorageEmulator(storage, 'localhost', 9199);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

// Export services
export { firestoreDB, auth, storage, functions, usingEmulator };
export default firebaseApp;